export const GenericCard = () => (
  <svg
    height="32px"
    viewBox="0 0 32 32"
    width="32px"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g className="nc-icon-wrapper">
      <rect
        fill="#e6e6e6"
        height="18"
        rx="3"
        ry="3"
        strokeWidth="0"
        width="28"
        x="2"
        y="7"
      />
      <path
        d="m27,7H5c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3v-12c0-1.657-1.343-3-3-3Zm2,15c0,1.103-.897,2-2,2H5c-1.103,0-2-.897-2-2v-12c0-1.103.897-2,2-2h22c1.103,0,2,.897,2,2v12Z"
        opacity=".15"
        strokeWidth="0"
      />
      <path
        d="m27,8H5c-1.105,0-2,.895-2,2v1c0-1.105.895-2,2-2h22c1.105,0,2,.895,2,2v-1c0-1.105-.895-2-2-2Z"
        fill="#fff"
        opacity=".2"
        strokeWidth="0"
      />
      <rect
        fill="#edab40"
        height="5"
        rx="1.5"
        ry="1.5"
        strokeWidth="0"
        width="6"
        x="5"
        y="11"
      />
      <path
        d="m9,20h-3.25c-.4141,0-.75-.3359-.75-.75s.3359-.75.75-.75h3.25c.4141,0,.75.3359.75.75s-.3359.75-.75.75Z"
        opacity=".15"
        strokeWidth="0"
      />
      <path
        d="m14.75,20h-3.25c-.4141,0-.75-.3359-.75-.75s.3359-.75.75-.75h3.25c.4141,0,.75.3359.75.75s-.3359.75-.75.75Z"
        opacity=".15"
        strokeWidth="0"
      />
      <path
        d="m20.5,20h-3.25c-.4141,0-.75-.3359-.75-.75s.3359-.75.75-.75h3.25c.4141,0,.75.3359.75.75s-.3359.75-.75.75Z"
        opacity=".15"
        strokeWidth="0"
      />
      <path
        d="m26.25,20h-3.25c-.4141,0-.75-.3359-.75-.75s.3359-.75.75-.75h3.25c.4141,0,.75.3359.75.75s-.3359.75-.75.75Z"
        opacity=".15"
        strokeWidth="0"
      />
    </g>
  </svg>
);
